import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 *
 * Search for click sync process logs.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.CLICK_SYNC_PROCESS_LOGS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const ClickSyncProcessLogService = {
  FindMany
}

export default ClickSyncProcessLogService
